export default {
    title: `Les essentiels`,
    subTitle: `L’activité économique vue par Alan Mudie, responsable de la stratégie d’investissement de Société Générale Private Banking.`,
    keyFigures: [
          {
            figure: 15,
            suffix: `%`,
            content: `D’après l’OCDE, c’est la contribution de l’amélioration de la qualité de l’air à la croissance du PIB en Europe (période 2010-2015). Cette étude fournit la première démonstration que la pollution de l’air entraîne une baisse de l’activité économique, à travers l’absentéisme et la réduction des capacités des travailleurs. Les résultats suggèrent que les politiques publiques de réduction de la pollution atmosphérique peuvent contribuer positivement à la croissance économique.`,
            source: `Source: <a href="http://oecd-ilibrary.org" target="_blank">oecd-ilibrary.org</a><br/>12 déc. 2019.`,
            noMarge: true,
        },

        {
            figure: 316,
            suffix: `Md$`,
            content: `L’Afrique pourrait augmenter son PIB de 316 milliards de dollars (+ 10 %) d’ici à 2025 si chaque pays se hissait au niveau de l’Afrique du Sud, le pays ayant le niveau d’égalité hommes-femmes le plus élevé du continent. Au rythme des progrès actuels, l’Afrique pourrait mettre plus de 140 ans pour atteindre la parité entre les sexes.`,
            source: `Source: <a href="http://mckinsey.com" target="_blank">mckinsey.com</a>, nov. 2019.`,
        },

        {
            figure: 75,
            suffix: `$/t`,
            content: `D’après le FMI, il faudrait une taxe de 75 dollars par tonne de carbone, contre environ 2 dollars aujourd’hui, pour réussir à limiter la hausse des températures à 2 °C au-dessus des niveaux préindustriels, comme prévu par l’Accord de Paris.`,
            source: `Source: <a href="http://IMF.org" target="_blank">IMG.org</a>, déc. 2019.`,
            noMarge: true,
        },

        {
            figure: 73.6,
            figureDecimals: 1,
            suffix: `%`,
            content: `D’après une étude menée par Eurostat, le taux d’emploi des personnes âgées de 20 à 64 ans en zone euro a enregistré son niveau le plus élevé (73,6 %) en 2019.Lors de la première publication de l’indicateur, en 2000, le taux d’emploi était de 68 %.`,
            source: `Source: <a href="http://ec.europa.eu" target="_blank">ec.europa.eu</a>, mai 2019.`,
            noMarge: true,
        },
        {   
            figure: 2026,
            suffix: `Md$`,
            content: `C’est la capitalisation boursière la plus élevée de l’histoire des marchés financiers. Ce record, atteint le 16 décembre 2019, revient à Saudi Aramco, l’ancienne entreprise nationale qui exploite les réserves de pétrole d'Arabie saoudite.`,
            source: `Source: BNN Bloomberg, déc. 2019.`,
        },

        {
            figure: 60,
            suffix: `%`,
            content: `D’après une analyse des trajets en Uber aux États-Unis, plus de 15 % des clients versent un pourboire, même si les paiements sont anonymes et ne confèrent aucun avantage au voyageur. Près de 60 % des personnes ne versent jamais de pourboire, 1 % en versent systématiquement.`,
            source: `Source: <a href="http://nber.org" target="_blank">nber.org</a>, déc. 2019.`,
            noMarge: true,
        },

    ]
};

